module.exports = __webpack_public_path__ + "static/media/make_it_personal@2x.ad0dac6a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/make_it_personal@2x.png
 ** module id = 2084
 ** module chunks = 44
 **/